const userKey = "_servicos_user";
const INITIAL_STATE = {
    usuario: JSON.parse(localStorage.getItem(userKey)),
    usuarioLogado: null,
    validToken: false,
    saudacaoAniversario: null,
    message: {
        open: false,
        text: "",
        time: 5000,
        type: "success",
    },
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "TOKEN_VALIDATED":
            if (action.payload.valid) {
                localStorage.setItem(
                    userKey,
                    JSON.stringify({
                        ...action.payload.usuario,
                        token: state.usuario.token, //atualiza os dados do usuário, como id, nome, login, usuario, mas preserva o token, pra controlar quantos acessos tem simultaneo
                    })
                );
                return {
                    ...state,
                    validToken: true,
                    usuario: {
                        ...action.payload.usuario,
                        token: state.usuario.token,
                    },
                }; //atualiza os dados do usuário, como id, nome, login, usuario, mas preserva o token, pra controlar quantos acessos tem simultaneo
            } else {
                localStorage.removeItem(userKey);
                return { ...state, validToken: false, usuario: null, usuarioLogado: null };
            }

        case "ANIVERSARIO_PENDENTE":
            if (!action.payload || !action.payload.id) return state;
            return { ...state, saudacaoAniversario: action.payload };

        case "USER_FETCHED":
            if (!action.payload.id) return state;
            localStorage.setItem(userKey, JSON.stringify(action.payload));
            return {
                ...state,
                usuario: action.payload,
                validToken: true,
                saudacaoAniversario: null,
            };

        case "USER_MESSEGE":
            return { ...state, message: action.payload };

        case "USER_SESSAO":
            return { ...state, usuarioLogado: action.payload };

        default:
            return state;
    }
};
